import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import TrueImpactIconButton from './TrueImpactIconButton';
import { COLORS } from '../settings/variables/Colors';
import { SPACERS } from '../settings/variables/Spacers';
import { faClose } from '@fortawesome/pro-light-svg-icons';

const StyledDiv = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  padding: ${SPACERS.tiny} 0;
  color: ${COLORS.whiteBase};
  background-color: ${COLORS.critical};
  text-align: center;
  .close-button {
    position: absolute;
    top: 50%;
    right: 8px;
    transform: translateY(-50%);
  }
`;

const TrueImpactServiceBanner: React.FC = () => {
  const [show, setShow] = useState<boolean>(false);

  const handleClose = useCallback(() => {
    setShow(false);
  }, [setShow]);

  if (!show) {
    return null;
  }

  return (
    <StyledDiv className="true-impact-service-banner">
      Apologies for any temporary interruptions in service! True Impact is
      currently undergoing routine maintenance and will be fully available
      shortly. Thank you for your patience!
      <TrueImpactIconButton
        icon={faClose}
        color="whiteBase"
        backgroundColor="criticalSubdued"
        className="close-button"
        onClick={handleClose}
        label="Close"
      />
    </StyledDiv>
  );
};

export default TrueImpactServiceBanner;
